// i18n area 'storage' — locale da-DK (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.da-DK.meta.json.
import type { enUS } from './storage'

export const daDK: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Opret storage',
      path: 'Sti',
      pathHint: 'Absolut sti under en tilladt rod (default /var/lib/tvirt/pools/)',
      shared: 'Delt storage',
      sharedChip: 'delt',
      sharedVerifiedChip: 'delt · verificeret',
      sharedVerifiedTooltip: 'Delingen er verificeret: krydssonderne bekræfter, at hvert medlem ser de data, de andre har skrevet.',
      sharedDisputedChip: 'delt · IKKE verificeret',
      sharedDisputedTooltip: 'Delingen er IKKE verificeret',
      sharedDisputedPair: '{observer} ser ikke de data, {writer} har skrevet',
      sharedHint: 'Netværksshare monteret lokalt på samme sti på hvert medlem — forudsætning for live migration (deklarativt).',
      sharedDanger: 'FARE — TVirt TROR på dette flag: tænder du det, antager hvert medlem at se DE SAMME bytes på denne sti. På en mappe, der IKKE er en reelt delt share (NFS/CIFS/cluster-filsystem), er resultatet korruption og datatab ved den første migrering eller den første HA-genstart på en anden node. Tænd det kun, hvis stien er en share monteret identisk på hver node.',
      type: 'Type',
      capacity: 'Kapacitet',
      provisioned: 'Allokeret',
      provisionedOvercommit: 'Potentiel forpligtelse ud over kapaciteten: thin-volumener kan vokse op til {n} GiB.',
      phase: { ready: 'Klar', degraded: 'Degraderet', error: 'Fejl' },
      tabConfig: 'Konfiguration',
      tabCapacity: 'Kapacitet og tilstand',
      cardIdentity: 'Identitet',
      cardPlacement: 'Placering',
      cardConnection: 'Forbindelse',
      usedReal: 'Reelt forbrug',
      capacityUnknown: 'Noden har endnu ikke rapporteret denne pools kapacitet — her opfindes ingen tal',
      overcommitHint: 'Forpligtelse ud over kapaciteten: legitimt på thin-pools, hold øje med det reelle forbrug',
      supportedContent: 'Understøttet indhold',
      content: {
        disks: 'Diske',
        catalogFiles: 'Katalogfiler',
        backups: 'Backups',
        appVolumes: 'App-volumener'
      },
      defaultDiskFormat: 'Standard-diskformat',
      reserveGiB: 'Reserveret fri plads (GiB)',
      available: 'Tilgængelig',
      diskCount: 'Diske',
      filesystem: 'Filsystem',
      observedAt: 'Observeret',
      lostAtRow: 'Erklæret tabt den',
      sharedProbeRow: 'Delingsverifikation',
      sharedProbeNodes: 'Sonderede noder',
      reachableFrom: 'Erklæret rækkevidde',
      reachableFromHint: 'De noder, hvorfra denne storage skal kunne nås. En VM med diske, ISO-filer eller metadata herpå hverken starter eller migrerer til en node uden for denne liste. Alle medlemmer er forvalgt: indsnævr, som du vil. En node, der senere træder ind i clusteret, står udenfor, indtil du tilføjer den her.',
      reachableFromNone: 'ikke erklæret',
      reachableFromTags: 'Tilgængelighed pr. tag',
      reachableFromTagsHint: 'Vælger tag=værdi (kommaseparerede poster, AND): hvert medlem med disse tags erklæres tilgængeligt — dynamisk: tag en node, og den kommer med.',
      reachableFromTagsInvalid: 'Ugyldigt format — brug tag=værdi, kommasepareret',
      reachableResolved: 'Opløste noder: {nodes}',
      reachableDeclaredNotSeen: 'erklæret, men ikke set af delingssonden på: {nodes}',
      reachableSeenNotDeclared: 'set, men ikke erklæret (uden for perimeteren) på: {nodes}',
      cephCluster: 'Håndteret Ceph-cluster',
      appGuardTitle: 'Storage i brug af Apps',
      appEphemeralGuard: 'denne storage er Apps efemere cluster-pool — skift den først fra App-siden, og slet den så.',
      appInUseGuard: 'her bor app-roots/-volumener: {apps} — flyt eller slet dem først.',
      releaseRequiredTitle: "Slet '{name}' og frigiv dens images?",
      releaseRequiredBatchTitle: 'Slet de valgte storages og frigiv deres images?',
      releaseRequiredBody: 'At frigive images sletter INGEN bytes: afregistreringen efterlader namespace på disken, images er blot ikke længere materialiseret, og hver reference fra scopes overlever som claim — registrer poolen igen, og de bliver adopteret på ny.',
      releaseConfirm: 'Slet og frigiv images'
    },
    lost: {
      chip: 'Tabt',
      action: 'Erklær tabt',
      confirmTitle: 'Erklær storagen tabt',
      confirmBody: 'Operatørattestering på eget erklærede ansvar: enhver task i kø eller i gang på denne storage eller dens objekter vil FEJLE, sletninger bliver rene registersletninger (intet arbejde på filsystemet), og nyt fysisk arbejde afvises. Dens bytes røres aldrig — vender volumenet tilbage til livet, så registrer det igen og kør en scan for at genadoptere det hele.',
      confirmSubmit: 'Erklær tabt',
      error: 'Attesteringen blev afvist'
    },
    findings: {
      action: 'Fundne objekter',
      title: 'Fundne objekter',
      empty: 'Ingen objekter fundet i storagens namespace',
      loadError: 'Kunne ikke indlæse de fundne objekter',
      actionError: 'Beslutningen blev afvist',
      colKind: 'Type',
      colObject: 'Objekt',
      colConflict: 'Konflikt',
      namespaceNotice:
        'Denne mappe var allerede initialiseret af et andet storage: identitetsseglet er blevet overskrevet med dette storages. Indholdet blev IKKE rørt — gennemgå de fundne objekter nedenfor, importér dem du har brug for, og afvis derefter denne besked.',
      kind: {
        disk: 'Disk',
        catalogFile: 'Katalogfil',
        vmMetadata: 'VM-metadata',
        namespace: 'Namespace',
        foreign: 'Fremmed',
        volumeGroup: 'Volume group'
      },
      vgAdopt: {
        action: 'Adoptér volume group',
        title: 'Adoptér volume group',
        intro:
          'Denne enhed bærer allerede en volume group med et TVirt-navn, men dens segl nævner intet storage registreret her. Det kan være det, et tidligere storage i DETTE cluster efterlod på LUN\'en — eller det, ET ANDET TVirt-cluster efterlod på en LUN, der har skiftet hænder: herfra ser de to tilfælde ens ud, og derfor bestemmer ingen for dig.',
        irreversible: 'Se på enheden, seglet og navnet, før du fortsætter: adoptionen kan ikke fortrydes.',
        device: 'Enhed',
        seal: 'Segl',
        sealNone: 'ingen (intet tvirt.storageId-tag)',
        renameTo: 'Den omdøbes til',
        renameNone: 'Ingen omdøbning: navnet er allerede det, dette storage udleder',
        volumesNote:
          'De indeholdte volumes adopteres IKKE af denne handling: næste scan tilbyder dem én ad gangen, som almindelige fundne objekter.'
      },
      conflictChip: 'ID findes allerede',
      dismissedChip: 'Ignoreret',
      adopt: 'Adopter',
      adoptFileTitle: 'Importer til et katalog',
      adoptFileHint: 'Filer findes kun inde i kataloger: vælg destinationskataloget for den fundne fil.',
      purge: 'Slet fra disken',
      dismiss: 'Ignorer',
      purgeConfirmTitle: 'Slet fra disken',
      purgeConfirmBody: 'De fundne bytes for {id} fjernes fra storagen. Operationen kan ikke fortrydes.',
      taskStarted: 'Startet — fortsætter som task i baggrunden',
      scan: 'Scan storagen',
      scanStarted: 'Scanning startet…',
      scanDone: 'Scanning afsluttet — de fundne objekter er opdateret'
    },
    reinit: {
      action: 'Prøv initialisering igen'
    },
    wizard: {
      addButton: 'Tilføj',
      title: 'Tilføj storage',
      back: 'Tilbage',
      continue: 'Fortsæt',
      selectHint: 'Vælg en protokol for at se, hvordan TVirt bruger den.',
      roadmap: 'Roadmap',
      server: 'Server',
      export: 'Eksporteret sti',
      share: 'Share',
      username: 'Brugernavn',
      password: 'Adgangskode',
      passwordHint: 'Kun skrivning: bruges til mount, vises aldrig igen.',
      credential: 'Credential',
      credentialManual: 'Indtast manuelt',
      credentialHint: 'En keystore-post af typen brugernavn og adgangskode — alternativet til at taste dem her.',
      credentialEmpty: 'Ingen credential af typen brugernavn og adgangskode i keystoret — opret den i System → Credentials, eller tast kontoen herunder.',
      options: 'Mount-options',
      optionsHint: 'Kommaseparerede, givet videre til mount -o, som de er.',
      portal: 'Portal',
      portalHint: 'host[:port] — standardporten er 3260.',
      target: 'Target-IQN',
      targetHint: 'iSCSI-targetets navn, begynder med iqn.',
      lun: 'LUN',
      wholeLunRow: 'På diskene: dette lager navngiver kun targetet',
      wholeLunHint: 'Dette lager navngiver kun targetet: dets LUN\'er bliver diske én ad gangen (Opret disk → overtag hel LUN), der skrives intet på targetet.',
      lunHint: 'LUN-nummeret på targetet — 0 i tvivlstilfælde.',
      chapCredential: 'Credential (CHAP)',
      chapCredentialHint: 'En keystore-post af typen CHAP (iSCSI) brugt ved login — hemmeligheden rejser aldrig med storagen.',
      chapNone: 'Ingen autentificering',
      chapEmpty: 'Ingen credential af typen CHAP (iSCSI) i keystoret — opret den i System → Credentials. Uden forbliver loginet uautentificeret.',
      address: 'Adresse',
      addressHint: 'Host eller IP for NVMe/TCP-targetet (traddr).',
      port: 'Port',
      portHint: 'Targetets TCP-port — 4420 hvis tom.',
      targetNqn: 'Target-NQN',
      targetNqnHint: 'Subsystemets NQN på targetet, begynder med nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace-ID inde i subsystemet — 1 i tvivlstilfælde.',
      dhchapCredential: 'Credential (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'En keystore-post af typen DH-HMAC-CHAP (NVMe) brugt ved forbindelsen — hemmeligheden rejser aldrig med storagen.',
      dhchapNone: 'Ingen autentificering',
      dhchapEmpty: 'Ingen credential af typen DH-HMAC-CHAP (NVMe) i keystoret — opret den i System → Credentials. Uden forbliver forbindelsen uautentificeret.',
      monitors: 'Monitorer',
      monitorsHint: 'Endpoints for Ceph-monitorerne, host[:port], kommaseparerede eller én pr. linje — standardport 6789.',
      pool: 'Pool',
      poolHint: 'RBD-poolen, der skal konsumeres — ét RBD-image pr. disk.',
      fs: 'Filsystem',
      fsHint: 'CephFS-filsystemets navn (mds_namespace ved mount).',
      fsPath: 'Sti inde i filsystemet',
      fsPathHint: 'Absolut sti inde i filsystemet, som storagen monterer — / hvis du er i tvivl.',
      cephxCredential: 'Credential (cephx)',
      cephxCredentialHint: 'En keystore-post af typen cephx: brugernavn = klientnavn (client.…), secret = base64-nøglen. Obligatorisk.',
      cephxNone: 'Ingen cephx-credential i keystoret — opret en (type: cephx) i System → Credentials, eller lad et håndteret Ceph-cluster præge den med "Foreslå som storage".',
      sharedByNature: 'Netværksstorage er delt af natur: hvert medlem monterer den på den samme sti, håndteret af TVirt.',
      error: 'Storagen blev afvist',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Andet',
        legacy: 'Legacy'
      },
      legacyHint: 'Fuldt understøttede — vi ville bare ikke vælge dem til en ny installation.',
      proto: {
        dir: {
          name: 'Lokal mappe',
          desc: 'En mappe på noden: enkel og hurtig. Den er LOKAL for én node, medmindre stien er en reelt delt share — at markere den delt, når den ikke er det, koster data.',
          usage: 'TVirt opbevarer VM-diske, ISO-/disk-images og templates her.'
        },
        nfs: {
          name: 'NFS',
          desc: 'En NFS-export monteret af clusteret — delt af natur.',
          usage: 'Huser VM-diske, ISO-/disk-images og templates.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'En Windows/Samba-share monteret af clusteret — delt af natur.',
          usage: 'Huser VM-diske, ISO-/disk-images og templates.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Et fjernfilsystem via SSH — uden behov for NAS-export.',
          usage: 'På roadmappen.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Blok-LUN via IP med delt LVM ovenpå.',
          usage: 'Kun diske — ét thin-volumen pr. disk; huser hverken ISO-images eller templates.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Block devices distribueret over et Ceph-cluster.',
          usage: 'Kun diske — ét RBD-image pr. disk, åbnet nativt af QEMU; huser ingen ISO-images.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Cephs distribuerede filsystem, monteret af kernen på clusteret — shared by nature.',
          usage: 'Huser VM-diske, ISO-/disk-images og templates — dir-familien på et Ceph-filsystem (cephx-credential obligatorisk).'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI-LUN på FibreChannel-fabric — den klassiske FC-SAN.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Samme SCSI på FibreChannel, med FC-frames indkapslet i Ethernet.' },
        'iscsi-lun': {
          name: 'iSCSI (hele LUN\'er)',
          desc: 'iSCSI-targetet som bærer af hele LUN\'er: hver disk ER en LUN, givet rå til gæsten — ingen LVM imellem.',
          usage: 'Kun diske — én hel LUN pr. disk, overtaget som den er; SAN-hjemmet for diske med delt skrivning.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (hele namespaces)',
          desc: 'NVMe-subsystemet som bærer af hele namespaces: hver disk ER et namespace, givet råt til gæsten.',
          usage: 'Kun diske — ét helt namespace pr. disk, overtaget som det er; delt skrivning ja, SCSI persistent reservations nej.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Fjern-NVMe — ingen SCSI i stien — over almindelig TCP, med delt LVM ovenpå.',
          usage: 'Kun diske — ét thin-volumen pr. disk; huser hverken ISO-images eller templates.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Fjern-NVMe på FibreChannel-fabric.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe på det FibreChannel-fabric, som FCoE transporterer inde i Ethernet — FCoE- og NVMe/FC-lagene stablet.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI med datastien flyttet til RDMA — et hvilket som helst fabric (InfiniBand, iWARP, RoCE). Overhalet af NVMe/RDMA, stadig til stede i arrays og i ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Nativ SCSI over RDMA, æraen før iSER: InfiniBand (med fabric-discovery) og RoCE — overlever i ældre HPC-storage.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Fjern-NVMe over et hvilket som helst RDMA-fabric — InfiniBand, iWARP, RoCE v1 og v2: én enkelt konfiguration, det er noden, der siger, hvilket den har.' },
        s3: { name: 'S3', desc: 'S3-kompatibel object storage — images og backupper.' }
      }
    },
    catalogs: {
      title: 'Kataloger',
      createTitle: 'Opret katalog',
      editTitle: 'Rediger katalog',
      docTitle: 'Katalog',
      notFound: 'Dette katalog findes ikke (længere?)',
      scopeHint: 'Den, der læser dette scope, ser (og kan bruge) hver fil i kataloget',
      files: 'Filer',
      noFiles: 'Ingen filer',
      count: {
        iso: 'ISO',
        ctRootfs: 'Tpl CT',
        vmTemplate: 'Tpl VM',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },
      systemChip: 'system',
      systemTooltip: 'Systemkatalog: huser platformens indbyggede objekter og kan ikke redigeres'
    },
    catalogFiles: {
      catalog: 'Katalog',
      kindLabel: 'Type',
      physicalSize: 'Fysisk størrelse',
      virtualSize: 'Virtuel størrelse',
      importTemplateAction: 'Importer som VM Template',
      importTemplateLegacy: 'Intet erklæret format — brugbar som seed til diske, ikke importerbar',
      importTemplateTitle: 'Importer som VM Template',
      importTemplateSubmit: 'Importer',
      importTemplateError: 'Importen mislykkedes',
      importTemplateHint: 'Pakken .tvtpl bliver en VM Template: manifestets frosne hardware plus én disk pr. entry i arkivet, hver verificeret mod sin checksum. NIC og CD/DVD-medier er ikke en del af et arkiv — tilføj dem efter importen.',
      importTemplateQcow2Hint: 'En nøgen qcow2 bliver en template med ÉN disk og den erklærede default-hardware: linux-profil, UEFI, 2 vCPU, 2048 MiB, boot fra dens eneste disk. Ret til ved deploy.',
      importTemplateName: 'Templatens navn',
      importTemplateNameHint: 'Tomt = {name} (-import-<n> hvis optaget)',
      importTemplateStorage: 'Storage til diskene',
      importTemplateMetadataStorage: 'Metadata-storage',
      importTemplateMetadataHint: 'En blok-storage huser ikke VM-metadata (firmware, varstore) — vælg en dir/nfs/cifs.',
      importTemplateStarted: 'Import startet — templaten dukker op i fanen Templates, når tasken lukker.',
      kind: {
        iso: 'ISO-image',
        'ct-rootfs': 'CT-rootfs',
        'vm-template': 'VM-template',
        'oci-image': 'OCI-image',
        'firmware-ovmf': 'OVMF-firmware'
      },
      title: {
        iso: 'ISO-images',
        'ct-rootfs': 'CT-templates',
        'vm-template': 'VM-templates',
        'oci-image': 'OCI-images',
        'firmware-ovmf': 'OVMF-firmware'
      },
      createTitle: {
        iso: 'Tilføj ISO-image',
        'ct-rootfs': 'Registrer CT-template',
        'vm-template': 'Tilføj VM-template',
        'oci-image': 'Tilføj OCI-image',
        'firmware-ovmf': 'Tilføj OVMF-firmware'
      },
      formatHint: 'Udledt af den valgte fils endelse — ret det, hvis den gættede forkert',
      tarballHint: 'En rootfs-tarball i standard-LXC-formatet (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, eller en ren .tar)',
      ociArchiveHint: 'En docker-archive-/oci-archive-tarball (.tar eller .tar.gz), for eksempel fra docker save',
      uploadResumeHint: 'Upload afbrudt — filen afventer upload: send igen med den samme fil for at genoptage',
      moveTitle: 'Flyt fil',
      moveHint: 'To uafhængige dimensioner: Katalog flytter linket (samme id, ingen bytes flyttes, scope bliver destinationskatalogets); Storage flytter dataene — hver forbundet kopi følger med, afvises mens filen er i brug. Vælges begge: først kataloget, så storagen.',
      moveCatalog: 'Destinationskatalog',
      moveCatalogHint: 'Kun linket skifter hjem: en VM, der har filen monteret, skal kunne se destinationskataloget',
      keepCurrent: 'Behold som den er',
      rehomed: 'Link flyttet til det valgte katalog',
      copyAction: 'Kopier til katalog…',
      copyTitle: 'Kopier til katalog',
      copyLinkHint: 'Kopien er et nyt link til de samme data — intet duplikeres på storagen.',
      copyCatalog: 'Destinationskatalog',
      copyCatalogHint: 'Kopien er måden, en fil rejser mellem kataloger på',
      sameCatalog: 'Det samme som kilden',
      sharedObjectHint: 'Denne fils data deles af {count} forbundne kopier',
      deleteLastLink: 'Dette er det SIDSTE link til dette indhold: dataene på storagen slettes også.',
      deleteLinkOnly: 'Kun dette link fjernes — dataene består, stadig tilgængelige fra de andre forbundne kopier ({count}).',
      noCatalog: 'Der findes intet katalog — opret et',
      inlineCatalogName: 'Katalogets navn',
      embeddedChip: 'indbygget',
      embeddedStorage: 'Indbygget i platformen',
      embeddedNoMove: 'Indbygget platformfil: den bor ikke på nogen storage — klon den i stedet',
      embeddedCopyHint: 'Klonen materialiserer de indbyggede bytes på en rigtig storage: vælg destinations-storage og -katalog — kopien er en normal fil',
      sourceEmbedded: 'Indbygget i platformen',
      nodesRow: 'Tilstedeværelse pr. node',
      nodesSummary: '{present} af {total} noder har den',
      nodePresent: 'til stede',
      nodeMissing: 'mangler',
      nodeUnknown: 'endnu ikke rapporteret',
      nodesHint: 'Aktivet ligger på hver nodes disk (pakken trantor-tvirt-assets): en node uden det kan hverken definere en VM med denne firmware eller levere Guest Tools. Forskellige versioner på tværs af noder er normalt under en rullende opdatering.',
      downloadAction: 'Download',
      downloadNotReady: 'Indholdet er ikke klar endnu — download kræver en ready-fil',
      downloadDenied: 'Din rolle inkluderer ikke catalog.download — at downloade de rå bytes er en rettighed adskilt fra brugen af filen',
      objectRow: 'Storage-objekt',
      objectLinksRow: 'Forbundne kopier',
      declaredChecksum: 'Erklæret SHA-256',
      usedByRow: 'Brugt af',
      usedByVms: 'VM',
      usedByDisks: 'Diske',
      transferRow: 'Overførsel',
      storageLockHint: 'Ændres kun med handlingen Flyt'
    },
    objects: {
      action: 'Udforsk indhold',
      title: 'Storagens indhold',
      hint: 'Read-only optælling af, hvad der bor på denne storage — hvert objekt håndteres fra sin egen sektion.',
      empty: 'Ingen objekter registreret på denne storage',
      loadError: 'Kunne ikke indlæse indholdet',
      colDetail: 'Detalje',
      manage: 'Håndter i dens sektion',
      kind: {
        disk: 'Disk',
        catalogFile: 'Katalogfil',
        ociBlob: 'OCI-blob',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM-metadata',
        appRoot: 'App-root',
        appVolume: 'App-volumen'
      }
    },
    inventory: {
      tabCatalogs: 'Kataloger',
      storage: 'Storage',
      sizeGib: 'Størrelse (GiB)',
      format: 'Format',
      size: 'Størrelse',
      sourceType: 'Kilde',
      sourceFile: 'Filupload',
      sourceUrl: 'Download fra URL',
      file: 'Fil',
      url: 'URL',
      checksum: 'SHA-256-checksum',
      checksumHint: 'Obligatorisk: downloadet verificeres mod denne SHA-256',
      verifyChecksum: 'Verificer checksum',
      checksumOffHint: 'Downloadet accepteres uden verifikation — den beregnede SHA-256 registreres alligevel',
      uploading: 'Uploader…',
      move: {
        action: 'Flyt',
        diskTitle: 'Flyt disk',
        target: 'Destinations-storage',
        diskHint: 'Disken beholder sin identitet: dens bytes rejser til den valgte storage. En VM, der bruger den, skal være slukket; med snapshots til stede afviser en iSCSI-side flytningen.',
        noTargets: 'Ingen kompatibel destinations-storage',
        submit: 'Flyt',
        error: 'Flytningen blev afvist'
      },
      clone: {
        action: 'Klon',
        title: 'Klon disk',
        name: 'Kopiens navn',
        storage: 'Destinations-storage',
        sameStorage: 'Samme som kilden',
        linked: 'Linked clone',
        linkedHint: 'Øjeblikkeligt qcow2-overlay lænket til kildedisken (kun qcow2-kilder). Default er en fuld kopi.',
        linkedCrossHint: 'En linked clone bliver på kildens storage: vælg "Samme som kilden" for at aktivere den.',
        submit: 'Klon',
        error: 'Kloningen blev afvist'
      },
      copy: {
        action: 'Kopier',
        name: 'Kopiens navn',
        storage: 'Destinations-storage',
        sameStorage: 'Samme som kilden',
        submit: 'Kopier',
        error: 'Kopieringen blev afvist'
      },
      taskStarted: 'Startet — fortsætter som task i baggrunden',
      cephObjects: 'Gå til objektdetaljerne på Ceph',
      phase: {
        ready: 'Klar',
        creating: 'Oprettes',
        'awaiting-upload': 'Afventer upload',
        downloading: 'Downloader',
        verifying: 'Verificerer',
        deleting: 'Slettes',
        error: 'Fejl',
        'in-use': 'I brug'
      }
    }
  }
}
